import { Component, inject } from '@angular/core';
import { VariableTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VariableTypeCreateDto,
  VariableTypeDto,
  VariableTypeExcelDownloadDto,
  VariableTypeUpdateDto,
} from '../proxy/controlling/dtos/variable-type';
import { VARIABLETYPE_CONFIG, VARIABLETYPE_FIELDS } from './variable-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-variable-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VariableTypeService, ConfirmationService],
  templateUrl: './variable-type.html',
  styleUrl: './variable-type.scss',
})
export class VariableType extends BaseCrudComponent<
  VariableTypeDto,
  VariableTypeCreateDto,
  VariableTypeUpdateDto,
  VariableTypeExcelDownloadDto
> {
  service = inject(VariableTypeService);
  config = VARIABLETYPE_CONFIG;
  fields = VARIABLETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: VariableTypeDto): VariableTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      groupingTypeOfVariableId: data.groupingTypeOfVariableId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VariableType';
  }
}
